(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const hamburgerBtn = document.querySelector('.header__hamburger');
  const sectionNav = document.getElementById('section-nav');
  const closeBtn = document.querySelector('.section-nav__close');
  const overlay = document.querySelector('.section-nav__overlay');

  function openMenu() {
    sectionNav.setAttribute('aria-hidden', 'false');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    sectionNav.setAttribute('aria-hidden', 'true');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburgerBtn && sectionNav) {
    hamburgerBtn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);

    // Close on link click (smooth scroll)
    const navLinks = sectionNav.querySelectorAll('.section-nav__link');
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          e.preventDefault();
          const target = document.querySelector(href);
          if (target) {
            closeMenu();
            setTimeout(() => {
              target.scrollIntoView({ behavior: 'smooth' });
            }, 300);
          }
        } else {
          closeMenu();
        }
      });
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sectionNav.getAttribute('aria-hidden') === 'false') {
        closeMenu();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-facility"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slideshows = document.querySelectorAll('[data-slideshow]');

    slideshows.forEach(function(slideshow) {
      const slides = slideshow.querySelectorAll('.location-facility__slide');
      if (slides.length <= 1) return;

      let currentIndex = 0;
      const interval = 4000; // 4 seconds

      function nextSlide() {
        slides[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % slides.length;
        slides[currentIndex].classList.add('is-active');
      }

      setInterval(nextSlide, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
